var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeleteV2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.61333 16C2.14667 16 1.75 15.8341 1.42333 15.5022C1.09667 15.1704 0.933333 14.7674 0.933333 14.2933V2.25185H0V0.82963H4.2V0H9.8V0.82963H14V2.25185H13.0667V14.2933C13.0667 14.7674 12.9033 15.1704 12.5767 15.5022C12.25 15.8341 11.8533 16 11.3867 16H2.61333ZM11.6667 2.25185H2.33333V14.2933C2.33333 14.3723 2.36071 14.4397 2.41547 14.4953C2.4696 14.5503 2.53556 14.5778 2.61333 14.5778H11.3867C11.4489 14.5778 11.5111 14.5462 11.5733 14.483C11.6356 14.4198 11.6667 14.3565 11.6667 14.2933V2.25185ZM4.57333 12.6815H5.97333V4.14815H4.57333V12.6815ZM8.02667 12.6815H9.42667V4.14815H8.02667V12.6815ZM2.33333 2.25185V14.5778V14.2933V2.25185Z",
    fill: "#8CB4C2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteV2);
export default __webpack_public_path__ + "static/media/deleteV2.56d29aa7.svg";
export { ForwardRef as ReactComponent };